export enum SocketActions {
    UPDATE_NAME = 1,
    UPDATE_AMOUNT,
    UPDATE_PAYMENT_STATUS,
    LIST_USERS,
    JOIN_CHANNEL,
    DO_HANDSHAKE,
    CLOSE_ROOM,
    UPDATE_CONFIG,
    REQUEST_CONFIG,
    RESET_CONFIG,
    UPDATE_ORDER,
}
